import React from 'react';
import { useNavigate } from 'react-router-dom';

const PrivacyPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#F1F5F9', fontFamily: "'Zen Kaku Gothic New', sans-serif" }}>
      {/* ヘッダー */}
      <header
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.92)',
          backdropFilter: 'blur(14px)',
          borderBottom: '1px solid rgba(37, 99, 235, 0.1)',
          padding: '1rem 2rem',
        }}
      >
        <div
          style={{
            maxWidth: '1200px',
            margin: '0 auto',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <div
            onClick={() => navigate('/')}
            style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}
          >
            <span style={{ fontSize: '0.78rem', fontWeight: 700, color: '#64748B', letterSpacing: '0.06em' }}>
              勤怠管理
            </span>
            <span
              style={{
                fontFamily: "'Outfit', sans-serif",
                fontWeight: 800,
                fontSize: '1.45rem',
                color: '#2563EB',
                letterSpacing: '-0.03em',
              }}
            >
              キン<b style={{ color: '#1A2E4A', fontWeight: 800 }}>ログ</b>
            </span>
          </div>
          <button
            onClick={() => navigate('/')}
            style={{
              padding: '9px 22px',
              backgroundColor: 'transparent',
              border: '2px solid #2563EB',
              borderRadius: '50px',
              color: '#2563EB',
              cursor: 'pointer',
              fontSize: '0.88rem',
              fontWeight: 600,
              transition: 'all 0.2s',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#2563EB';
              e.currentTarget.style.color = '#fff';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.color = '#2563EB';
            }}
          >
            トップページに戻る
          </button>
        </div>
      </header>

      {/* コンテンツ */}
      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '3rem 2rem' }}>
        <h1 style={{ fontSize: '2rem', fontWeight: 900, marginBottom: '2rem', color: '#1E293B' }}>
          プライバシーポリシー
        </h1>

        <div style={{ backgroundColor: '#fff', padding: '2rem', borderRadius: '22px', lineHeight: 1.8, boxShadow: '0 4px 20px rgba(0, 0, 0, 0.06)' }}>
          <p style={{ color: '#64748B', marginBottom: '2rem' }}>
            株式会社立山システム（以下「当社」といいます）は、本サービスにおけるユーザーの個人情報の取扱いについて、以下のとおりプライバシーポリシー（以下「本ポリシー」といいます）を定めます。
          </p>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1E293B' }}>
              第1条（個人情報）
            </h2>
            <p style={{ color: '#64748B' }}>
              「個人情報」とは、個人情報保護法にいう「個人情報」を指すものとし、生存する個人に関する情報であって、当該情報に含まれる氏名、生年月日、住所、電話番号、メールアドレス、その他の記述等により特定の個人を識別できる情報及び容貌、指紋、声紋にかかるデータ、及び健康保険証の保険者番号などの当該情報単体から特定の個人を識別できる情報（個人識別情報）を指します。
            </p>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1E293B' }}>
              第2条（個人情報の収集方法）
            </h2>
            <p style={{ color: '#64748B', marginBottom: '0.5rem' }}>
              当社は、ユーザーが利用登録をする際に、企業名、メールアドレス等の個人情報をお尋ねすることがあります。また、ユーザーと提携先などとの間でなされたユーザーの個人情報を含む取引記録や決済に関する情報を、当社の提携先（情報提供元、広告主、広告配信先などを含みます。以下「提携先」といいます）などから収集することがあります。
            </p>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1E293B' }}>
              第3条（個人情報を収集・利用する目的）
            </h2>
            <p style={{ color: '#64748B', marginBottom: '0.5rem' }}>当社が個人情報を収集・利用する目的は、以下のとおりです。</p>
            <ol style={{ paddingLeft: '1.5rem', color: '#64748B' }}>
              <li>本サービスの提供・運営のため</li>
              <li>ユーザーからのお問い合わせに回答するため（本人確認を行うことを含む）</li>
              <li>ユーザーが利用中のサービスの新機能、更新情報、キャンペーン等及び当社が提供する他のサービスの案内のメールを送付するため</li>
              <li>メンテナンス、重要なお知らせなど必要に応じたご連絡のため</li>
              <li>利用規約に違反したユーザーや、不正・不当な目的でサービスを利用しようとするユーザーの特定をし、ご利用をお断りするため</li>
              <li>ユーザーにご自身の登録情報の閲覧や変更、削除、ご利用状況の閲覧を行っていただくため</li>
              <li>有料サービスにおいて、ユーザーに利用料金を請求するため</li>
              <li>上記の利用目的に付随する目的</li>
            </ol>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1E293B' }}>
              第4条（利用目的の変更）
            </h2>
            <ol style={{ paddingLeft: '1.5rem', color: '#64748B' }}>
              <li>当社は、利用目的が変更前と関連性を有すると合理的に認められる場合に限り、個人情報の利用目的を変更するものとします。</li>
              <li>
                利用目的の変更を行った場合には、変更後の目的について、当社所定の方法により、ユーザーに通知し、または本ウェブサイト上に公表するものとします。
              </li>
            </ol>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1E293B' }}>
              第5条（個人情報の第三者提供）
            </h2>
            <ol style={{ paddingLeft: '1.5rem', color: '#64748B' }}>
              <li>
                当社は、次に掲げる場合を除いて、あらかじめユーザーの同意を得ることなく、第三者に個人情報を提供することはありません。ただし、個人情報保護法その他の法令で認められる場合を除きます。
                <ul style={{ paddingLeft: '1.5rem', marginTop: '0.5rem' }}>
                  <li>人の生命、身体または財産の保護のために必要がある場合であって、本人の同意を得ることが困難であるとき</li>
                  <li>
                    公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難であるとき
                  </li>
                  <li>
                    国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき
                  </li>
                </ul>
              </li>
              <li>
                前項の定めにかかわらず、次に掲げる場合には、当該情報の提供先は第三者に該当しないものとします。
                <ul style={{ paddingLeft: '1.5rem', marginTop: '0.5rem' }}>
                  <li>当社が利用目的の達成に必要な範囲内において個人情報の取扱いの全部または一部を委託する場合</li>
                  <li>合併その他の事由による事業の承継に伴って個人情報が提供される場合</li>
                </ul>
              </li>
            </ol>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1E293B' }}>
              第6条（個人情報の開示）
            </h2>
            <ol style={{ paddingLeft: '1.5rem', color: '#64748B' }}>
              <li>
                当社は、本人から個人情報の開示を求められたときは、本人に対し、遅滞なくこれを開示します。ただし、開示することにより次のいずれかに該当する場合は、その全部または一部を開示しないこともあり、開示しない決定をした場合には、その旨を遅滞なく通知します。
                <ul style={{ paddingLeft: '1.5rem', marginTop: '0.5rem' }}>
                  <li>本人または第三者の生命、身体、財産その他の権利利益を害するおそれがある場合</li>
                  <li>当社の業務の適正な実施に著しい支障を及ぼすおそれがある場合</li>
                  <li>その他法令に違反することとなる場合</li>
                </ul>
              </li>
            </ol>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1E293B' }}>
              第7条（個人情報の訂正及び削除）
            </h2>
            <ol style={{ paddingLeft: '1.5rem', color: '#64748B' }}>
              <li>
                ユーザーは、当社の保有する自己の個人情報が誤った情報である場合には、当社が定める手続きにより、当社に対して個人情報の訂正、追加または削除（以下「訂正等」といいます）を請求することができます。
              </li>
              <li>
                当社は、ユーザーから前項の請求を受けてその請求に応じる必要があると判断した場合には、遅滞なく、当該個人情報の訂正等を行うものとします。
              </li>
            </ol>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1E293B' }}>
              第8条（個人情報の利用停止等）
            </h2>
            <ol style={{ paddingLeft: '1.5rem', color: '#64748B' }}>
              <li>
                当社は、本人から、個人情報が、利用目的の範囲を超えて取り扱われているという理由、または不正の手段により取得されたものであるという理由により、その利用の停止または消去（以下「利用停止等」といいます）を求められた場合には、遅滞なく必要な調査を行います。
              </li>
              <li>
                前項の調査結果に基づき、その請求に応じる必要があると判断した場合には、遅滞なく、当該個人情報の利用停止等を行います。
              </li>
            </ol>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1E293B' }}>
              第9条（Cookie（クッキー）その他の技術の利用）
            </h2>
            <ol style={{ paddingLeft: '1.5rem', color: '#64748B' }}>
              <li>
                当社のサービスは、Cookie及びこれに類する技術を利用することがあります。これらの技術は、当社による本サービスの利用状況等の把握に役立ち、サービス向上に資するものです。Cookieを無効化されたいユーザーは、ウェブブラウザの設定を変更することによりCookieを無効化することができます。ただし、Cookieを無効化すると、本サービスの一部の機能をご利用いただけなくなる場合があります。
              </li>
              <li>
                当社は、本ウェブサイトの利用状況を把握し改善に役立てるため、Google LLC が提供するアクセス解析ツール「Googleアナリティクス」を利用しています。Googleアナリティクスは Cookie を利用して情報を収集しますが、氏名・メールアドレス等の個人を特定する情報は送信していません。また、パスワード再設定用のリンク等、機微な情報を含むURLのパラメータは送信対象から除外しています。収集された情報は Google 社のプライバシーポリシーに基づいて管理されます。データの収集を拒否されたい場合は、Google が提供する
                {' '}
                <a
                  href="https://tools.google.com/dlpage/gaoptout?hl=ja"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: '#2563EB' }}
                >
                  オプトアウト アドオン
                </a>
                {' '}
                をご利用ください。
              </li>
            </ol>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1E293B' }}>
              第10条（プライバシーポリシーの変更）
            </h2>
            <ol style={{ paddingLeft: '1.5rem', color: '#64748B' }}>
              <li>
                本ポリシーの内容は、法令その他本ポリシーに別段の定めのある事項を除いて、ユーザーに通知することなく、変更することができるものとします。
              </li>
              <li>当社が別途定める場合を除いて、変更後のプライバシーポリシーは、本ウェブサイトに掲載したときから効力を生じるものとします。</li>
            </ol>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1E293B' }}>
              第11条（安全管理措置）
            </h2>
            <p style={{ color: '#64748B', marginBottom: '0.5rem' }}>
              当社は、取り扱う個人データの安全管理のため、以下の措置を講じています。
            </p>
            <ul style={{ paddingLeft: '1.5rem', color: '#64748B' }}>
              <li>
                <strong>組織的安全管理措置</strong>：個人データの取扱責任者を定め、取扱状況を記録し、定期的に確認しています。
              </li>
              <li>
                <strong>人的安全管理措置</strong>：個人データの取扱いに関する留意事項を定め、これを遵守しています。
              </li>
              <li>
                <strong>物理的安全管理措置</strong>：個人データを取り扱う機器について、ディスク全体の暗号化を実施しています。
              </li>
              <li>
                <strong>技術的安全管理措置</strong>：通信の暗号化（TLS）、権限に応じたアクセス制御、認証情報のハッシュ化による保存、及び暗号化したうえで別拠点に保管する日次バックアップを実施しています。
              </li>
              <li>
                <strong>外的環境の把握</strong>：個人データを保管する国（日本国及びアメリカ合衆国）における個人情報の保護に関する制度を把握したうえで、安全管理措置を実施しています。
              </li>
            </ul>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1E293B' }}>
              第12条（個人データの取扱いの委託）
            </h2>
            <p style={{ color: '#64748B', marginBottom: '0.5rem' }}>
              当社は、本サービスの提供に必要な範囲で、以下のとおり個人データの取扱いを委託しています。
            </p>
            <ul style={{ paddingLeft: '1.5rem', color: '#64748B' }}>
              <li>Amazon Web Services, Inc.（メールの送信、バックアップの保管）／ 日本国（東京リージョン）</li>
              <li>GMOインターネットグループ株式会社（サーバーの提供）／ 日本国</li>
              <li>
                <strong>Stripe, Inc.（決済処理、請求書の発行）／ アメリカ合衆国</strong>
              </li>
              <li>
                <strong>Google LLC（ウェブサイトのアクセス解析）／ アメリカ合衆国</strong>
              </li>
              <li>Cloudflare, Inc.（自動投稿対策）／ アメリカ合衆国</li>
            </ul>
            <p style={{ color: '#64748B', marginTop: '0.5rem' }}>
              このうち Stripe, Inc.、Google LLC 及び Cloudflare, Inc. は外国にある第三者に該当します。同国における個人情報の保護に関する制度及び各社が講ずる個人情報の保護のための措置に関する情報は、お問い合わせ窓口までご請求ください。
            </p>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1E293B' }}>
              第13条（お問い合わせ窓口）
            </h2>
            <p style={{ color: '#64748B' }}>
              本ポリシーに関するお問い合わせ、及び保有個人データの開示・訂正・利用停止等のご請求は、下記の窓口までお願いいたします。ご請求にあたっては、当社所定の方法により本人確認をさせていただきます（手数料は無料です）。
              <br />
              <br />
              事業者の名称: 株式会社立山システム<br />
              所在地: 東京都豊島区東池袋二丁目62番8号 BIGオフィスプラザ池袋1206<br />
              代表者: 駒井大樹<br />
              メールアドレス: info@kinlog.jp
            </p>
          </section>

          <p style={{ textAlign: 'right', color: '#999', marginTop: '3rem' }}>2025年11月1日 制定 ／ 2026年8月2日 改定</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
